export enum BladApi {
    NIEZNANY_BLAD,
    NIEPRAWIDLOWE_HASLO,
    HASLA_ROZNIA_SIE,
}

export const KodBleduApi = new Map<number, BladApi>([
    [0, BladApi.NIEZNANY_BLAD],
    [1, BladApi.NIEPRAWIDLOWE_HASLO],
    [2, BladApi.HASLA_ROZNIA_SIE],
]);
